// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3SPzT","vLegacy":"SelectSecondary_vLegacy__2M4B2","error":"SelectSecondary_error__1M0nL","disabled":"SelectSecondary_disabled__3IBNF"};